<h2>FORMACIÓN CONTINUA Cursos Abiertos, Jornadas y Extensión</h2>
<div class='container-icons'>
    <a [href]="i.link" *ngFor='let i of iconos' class='item-icons'>
        <div class='div-img'>
            <img onerror="this.src='./assets/img/default.png'" [src]="i.path" onerror="this.src='./assets/img/default.png'" class='img-icon' alt="icono beneficio">
        </div>
        <p class="gray text-center mt-2 text-b">{{i.label}}</p>
    </a>
</div>